import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class BundleOffer extends Component {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateOffers);
    this.#setupReveal();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateOffers);
    this.#observer?.disconnect();
  }

  /**
   * Plays the entrance animation once the block scrolls into view.
   * The markup starts hidden via [data-animate]; [data-animate-ready] tells the CSS
   * fallback (which reveals the block if this script never runs) to stand down.
   */
  #setupReveal() {
    if (!this.hasAttribute('data-animate')) return;
    this.setAttribute('data-animate-ready', '');

    if (!('IntersectionObserver' in window)) {
      this.classList.add('is-visible');
      return;
    }

    this.#observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.classList.add('is-visible');
        this.#observer?.disconnect();
      },
      { threshold: 0.25 }
    );
    this.#observer.observe(this);
  }

  /**
   * Re-renders the offers so photos and links follow the selected color.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateOffers = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newOffers = event.detail.data.html.querySelector(`bundle-offer[data-block-id="${this.dataset.blockId}"]`);

    if (!newOffers) return;

    morph(this, newOffers, { childrenOnly: true });
  };
}

if (!customElements.get('bundle-offer')) {
  customElements.define('bundle-offer', BundleOffer);
}
